import {APIClient} from '../../utils/APIClient';
import {API_URL} from '../../settings/local_settings';
import {isOk} from '../../utils/apiResponse';

// Los idiomas del portal, cada uno escrito en su propia lengua y sin traducir: quien no entiende el
// idioma en que está la pantalla tiene que poder reconocer el suyo.
export const PORTAL_LANGUAGES = [
    {code: 'es', label: 'Español'},
    {code: 'en', label: 'English'},
];

// El código de idioma del portal (`es` / `en`) de un valor como el que guarda i18next o el login
// (`es`, `en-US`), o `null` si no es uno de los dos.
export function portalLanguageOf(language) {
    const code = String(language || '').slice(0, 2).toLowerCase();
    return PORTAL_LANGUAGES.some((option) => option.code === code) ? code : null;
}

// El idioma en que está la pantalla ahora (`es` si i18next no lo sabe).
export function currentPortalLanguage(i18n) {
    if (!i18n) return 'es';
    return portalLanguageOf(i18n.resolvedLanguage || i18n.language) || 'es';
}

// El idioma del usuario que todavía no se aplicó, o `null` si no hay nada que cambiar.
//
// El login guarda el idioma del usuario en LocalStorage pero no llama a `changeLanguage`, y el
// detector de i18next lee esa clave sólo al cargar la página: quien entraba sin recargar veía el
// portal en el idioma con que había abierto la pantalla de login.
export function pendingUserLanguage(i18n, storedLanguage) {
    const target = portalLanguageOf(storedLanguage);
    if (!target || !i18n || typeof i18n.changeLanguage !== 'function') return null;
    return currentPortalLanguage(i18n) === target ? null : target;
}

// Guarda el idioma del usuario logueado. Devuelve si se guardó.
//
// `POST user/<id>` pide los tres datos básicos juntos (nombre, idioma y zona horaria). El nombre y la
// zona horaria salen de `get-logged-user-data/`, que trae sólo los del propio usuario, y no del
// `GET user/<id>`: a un usuario del portal ese GET le devuelve la lista entera de clientes de la
// agencia. El id también sale de ahí, así que se edita siempre al dueño del token.
export async function saveUserLanguage(language) {
    const me = await new APIClient(API_URL + 'get-logged-user-data/').call('GET', {}, {cache: true});
    if (!isOk(me) || !me.id) return false;
    const response = await new APIClient(API_URL + 'user/' + me.id).call('POST', {
        name: me.name,
        language,
        timezone: me.timezone,
    });
    return isOk(response);
}
